import { getGraphQLID } from '../common/graphql';
import { getCustomerId } from '../common/offerData';
import { getLocale, getShop } from '../common/pageData';
import { getURLWithParamsFromArray } from '../common/util';

export const getURLWithBasicParams = (url: string, addSpecifier = true) => {
  const customerID = getCustomerId();
  const params = [
    {
      key: 'customerID',
      value: customerID ? getGraphQLID(customerID, 'Customer') : false,
    },
    { key: 'shopURL', value: getShop() },
    { key: 'locale', value: getLocale() },
  ].filter((param) => param.value);
  return getURLWithParamsFromArray(url, params, addSpecifier);
};
